var $ = jQuery;
jQuery(document).ready(function ($) {
	let skmLog = function () {
		console.log('SKM Ready');
	}
	skmLog();
	var w = $(window).width();

	stickyHeader();
	searchForm();
	heroSlider();
	hasSubMenu();
	mobileMenu();
	closeModalMenu();
	mobSubMenu();
	mobMenuPos();
	window.addEventListener('resize', () => {
		mobSubMenu();
		unSlicks();
		mobMenuPos();
	});
	formLabel();
	announcement();

	heroVideo();
	leaderModal();
	modalGallery();

	maps();
	slicks();
	scroll_link();

	single_post_slider();
	langMenu();


	function scroll_link() {
		$(".scroll").click(function (e) {
			e.preventDefault();
			var aid = $(this).attr("href");
			if (aid == "#maps") {
				$('html,body').animate({
					scrollTop: $(aid).offset().top - 280
				}, 'slow');
			} else {
				$('html,body').animate({
					scrollTop: $(aid).offset().top
				}, 'slow');
			}
		});
	}

});

// PREVENT DEFAULT
function preventDef(e) {
	e.preventDefault();
	e.stopPropagation();
}

// GET SIBLINGS ELEMENTS
var getSiblings = function(elem) {
	return Array.prototype.filter.call(elem.parentNode.children, function(sibling) {
			return sibling !== elem;
	});
};

// PARSE POST DATA
function postData(url = '', data) {
	return fetch(url, {
		method: 'POST', // *GET, POST, PUT, DELETE, etc.
		mode: 'cors', // no-cors, cors, *same-origin
		cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
		credentials: 'same-origin', // include, *same-origin, omit
		headers: {
			// 'Content-Type': 'application/json',
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		redirect: 'follow', // manual, *follow, error
		referrer: 'no-referrer', // no-referrer, *client
		body: data, // тип данных в body должен соответвовать значению заголовка "Content-Type"
	})
		.then(response => response.text()); // парсит JSON ответ в Javascript объект
}

// STICKY HEADER
function stickyHeader() {
	let siteHeader = document.getElementById('masthead'),
		topbar = document.getElementById('topbar'),
		header = siteHeader.querySelector('.header'),
		offset = topbar.offsetHeight,
		sticky = siteHeader.getBoundingClientRect().top,
		currentScroll = window.pageYOffset;
	window.onscroll = function () {
		if (window.pageYOffset > (sticky + offset + currentScroll)) {

			siteHeader.classList.add('sticky');
			document.body.style.paddingTop = (header.offsetHeight + offset) + 'px';
		} else {
			siteHeader.classList.remove('sticky');
			document.body.style.paddingTop = 0;
		}
	}
}

// ANNOUNCEMENT
function announcement() {
	let block = document.getElementById('announcement');
	if (block) {
		let close = block.querySelector('.close');
		close.addEventListener('click', () => {
			block.classList.add('hide');
			mobMenuPos();
		});
	}
}

/** ================
 * MOBILE MENU START
================= */

// MOBILE MENU
// loking mobile menu toggle button
function mobileMenu() {
	let el = document.querySelectorAll('.mobile-nav-toggle');
	for (var i = 0; i < el.length; i++) {
		el[i].addEventListener('click', function () {
			menuToggle(this);
			setTimeout(mobMenuPos(), 900);
			//mobMenuPos();
		});
	}
}

// close modal menu
function closeModalMenu() {
	document.addEventListener('click', (e) => {
		let close = document.querySelector('.mobile-nav-toggle');
		if (!e.target.closest('.main-nav-wrapper') && close.classList.contains('open')) {
			menuToggle(close);
		}
	});
}

// close & open mobile menu
function menuToggle(t) {
	document.querySelector('.menu-container').classList.toggle('active');
	t.classList.toggle('open');
	document.body.classList.toggle('open');
	let activeSubMenu = document.querySelector('.show-sub-menu');
	if (activeSubMenu) {
		activeSubMenu.classList.remove('show-sub-menu');
	}
}

// fix modal menu pos when announcement is open
function mobMenuPos() {
	let offsetT = document.getElementById('topbar').offsetHeight,
	offsetH = document.getElementById('header').offsetHeight,
		menu = document.querySelector('.menu-container');
	if (menu.classList.contains('active')) {
		menu.style.top = offsetT + offsetH + 'px';
	}
}

// open sub menu
function mobSubMenu() {
	let item = document.querySelectorAll('.main-menu .menu-item-has-children');
	item.forEach(el => {
		let link = el.querySelector('a:first-child'),
			back = el.querySelector('.back'),
			close = document.querySelector('.mobile-nav-toggle');
		if (window.innerWidth < 1200) {
			link.addEventListener('click', preventDef, false);
			link.addEventListener('click', (e) => {
				el.classList.add('show-sub-menu');
				prevMenu(back, el);
				document.querySelector('.menu-container').scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			});
		} else {
			link.removeEventListener('click', preventDef, false);
			if (close.classList.contains('open')) {
				menuToggle(close);
			}
		}
	});
}

// close sub menu
function prevMenu(back, parent) {
	back.addEventListener('click', (e) => {
		e.preventDefault();
		parent.classList.remove('show-sub-menu');
	})
}

/** ===============
 * MOBILE MENU END
================ */

// ADD ICON IF MENU ITEM HAS SUBMENU
function hasSubMenu() {
	let item = document.querySelectorAll('li.menu-item-has-children'),
		i = 0;
	for (i; i < item.length; i++) {
		let parenLink = item[i].querySelector('a');
		let subMenu = item[i].querySelector('.sub-menu');
		subMenu.insertAdjacentHTML('beforebegin', '<span class="arrow"></span>');
	}
}

/** =================
 * HERO SCRIPTS START
================== */
// HERO SLIDER
function heroSlider() {
	$('.hero-slider').slick();
}

// HERO VIDEO
function heroVideo() {
	$('.btn-play').each(function () {
		let that = $(this),
			videoWrapp = that.parent().siblings('.video-modal'),
			close = videoWrapp.find('.close');
		that.on('click', function (e) {
			e.preventDefault();
			videoWrapp.find('.mejs-play button').click();
			openModal(videoWrapp);
		});
		$(document).on("click", ".modal-bg, .close", function () {
			videoWrapp.find('.mejs-pause button').click();
			closeModal(videoWrapp);
		});
	});
}

/** =================
 * HERO SCRIPTS END
================== */

// LEADERSHIP MODAL
function leaderModal() {
	let wrapp = $('.leadership-wrapper'),
		slideWrapper = $('.leadership-slider-wrapper'),
		leader = wrapp.find('.leader'),
		close = $('.leadership-slider-wrapper .close');

	leader.each(function () {
		let that = $(this),
			index = that.parent().index();
		that.find('a').on('click', function (e) {
			e.preventDefault();
			openModal(slideWrapper);
			$('.leadership-slider').slick({
				initialSlide: index
			});
		});
	});

	$(document).on('click', '.modal-toggle, .modal-bg', function () {
		closeModal(slideWrapper);
		setTimeout(function () {
			$('.leadership-slider').slick('unslick');
		}, 500);

	});

}

// MODAL OPEN
function openModal(modal) {
	modal.fadeIn();
	$('body').addClass('show');
}
// MODAL CLOSE
function closeModal(modal) {
	modal.fadeOut();
	$('body').removeClass('show');
}

// SEARCH FORM
function searchForm() {
	let searchForm = document.forms.searchform;
	if (searchForm) {
		let submit = searchForm.elements.submit;
		document.addEventListener('click', (e) => {
			if (e.target.closest('#searchform')) {
				if (searchForm.classList.contains('collapsed')) {
					e.preventDefault();
					submit.disabled = false;
					searchForm.classList.remove('collapsed');
					e.stopPropagation();
				}
			} else {
				searchForm.classList.add('collapsed');
				submit.disabled = true;
			}
		});

	}
}

// CUSTOMIZE FORM LABEL
function formLabel() {
	let fields = document.getElementsByClassName('pretty-field');
	field = Array.prototype.filter.call(fields, (fields) => {
		let label = fields.querySelector('label'),
			input = fields.querySelector('input, textarea');
		if (input.value.length > 0) {
			label.classList.add('moveup')
		}
		input.addEventListener('focus', (e) => label.classList.add('moveup'), false);
		input.addEventListener('blur', () => {
			if (input.value.length === 0) {
				label.classList.remove('moveup');
			}
		}, false);

	});
}

// EVENT SLIDER
function slicks() {
	let events = $('.eventslider-mobile');
	if (!events.hasClass('slick-initialized')) {
		events.slick({
			mobileFirst: true,
			//settings: 'init',
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			rows: 0,
			centerMode: true,
			centerPadding: '50px',
			infinite: false,
			//variableWidth: true,
			responsive: [{
				breakpoint: 767,
				settings: 'unslick',
			}]
		});
	}
}

function unSlicks() {
	if ($(window).width() > 767 && $('.eventslider-mobile.slick-initialized').length) {
		$('.eventslider-mobile').slick('unslick');
	} else {
		slicks();
	}
}

// SVG MAP
function maps() {
	$(".map path").on("click", function () {
		var clic = $(this);
		if (clic.hasClass('avalible')) {

			$('.map .active').removeClass('active');
			clic.addClass('active');
			var id = clic.attr('id');
			var ids = id.substring(1);
			console.log($('#masthead').height());
			// $('#states').find('option').attr("selected", false);
			$('.tb.active').removeClass('active');
			$('#tb' + ids).addClass('active');
			$('#states').val(id.substring(1));
			$('html, body').animate({
        scrollTop: $('#tb' + ids).offset().top - $('#header').height()
    }, 500);
			// $('#states').find('option[value=' + id.substring(1) + ']').attr("selected", true);
		}
		if (clic.hasClass('notavalible')) {

			$('.map .active').removeClass('active');
			clic.addClass('active');
			var id = clic.attr('id');
			var ids = id.substring(1);
			console.log(id);
			$('#states').find('option').attr("selected", false);
			$('.tb.active').removeClass('active');
			$('#tbnot').addClass('active');
			$('#states').val(id.substring(1));
			$('#states').find('option[value=' + id.substring(1) + ']').attr("selected", true);
		}
	});
	$(" #states").change(function () {
		var clic = $(this).val();
		if (clic == 0) {
			$('.map .active').removeClass('active');
			$('.tb').removeClass('active');
			$('#tb' + clic).addClass('active');
			console.log(clic);
		} else {
			$('.map .active').removeClass('active');
			var c = $('.map path#s' + clic);
			if (c.hasClass('avalible')) {
				$('.map path#s' + clic).addClass('active');
				$('.tb').removeClass('active');
				$('#tb' + clic).addClass('active');
			}
			if (c.hasClass('notavalible')) {
				$('.map path#s' + clic).addClass('active');
				$('.tb').removeClass('active');
				$('#tbnot').addClass('active');
			}
			console.log(c.hasClass('avalible'));
		}
	});
}

// POST SLIDER
function single_post_slider() {
	$('.post-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		prevArrow: $('.post-slider-container .left'),
		nextArrow: $('.post-slider-container .right'),
	});
}

// LANG MENU
function langMenu() {
	let langWrapp = document.querySelector('.lang-menu');
	if(langWrapp) {
		let currLang = langWrapp.querySelector('.current-lang'),
		listLang = langWrapp.querySelector('.lang-dropdown');

		currLang.addEventListener('click', (e) => {
			console.log(e.target);
			langWrapp.classList.toggle('active');
		});
		listLang.querySelectorAll('.flag').forEach((lang) => {
			lang.addEventListener('click', (ev) => {
				ev.preventDefault();
				currLang.querySelector('.label').textContent = lang.text;
				langWrapp.classList.toggle('active');
			})
		})
	}
}

// LIGHTGALLERY
function modalGallery(){
	let galleries = document.querySelectorAll('.gallery');
	if (galleries) {
		galleries.forEach((gallery) => {
			let item = gallery.getElementsByClassName('gallery-item');
			Array.prototype.filter.call(item, (item) => {
				let img = item.querySelector('img').src;
				item.dataset.src = img;
			});
			lightGallery(gallery);
		})
	}
}

var $ = jQuery;

if (document.querySelector('.tax-events_cat')) {
  initDatepicker();
	filterByCat();
	highlightDate();
	buildFilterPanel();
	loadmoreEventsCnt();
	loadmoreEvents();
	checkEvent();
  toggleView();
}

// TOGGLE GRID / LIST VIEW
function toggleView() {
  let head = document.querySelector('.events-list-head'),
  body = document.querySelector('.events-list-body'),
  toggleBtn = head.querySelectorAll('.btn-view');
  toggleBtn.forEach(element => {
    let view = element.dataset.id;    
    element.addEventListener('click', () => {
      element.classList.add('active');
      getSiblings(element).forEach(sibl=>{
        sibl.classList.remove('active');
      });
      body.dataset.view = view;
    });
  });
}

// INIT DATEPICKER
function initDatepicker() {
	$("#datepicker").datepicker({
		// minDate: new Date(), 
		dateFormat: 'dd-mm-yy',
		showOtherMonths: true,
		dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
		onSelect: function (date, datepicker) {
			datepicker.inline = false;
			$(this).find(".ui-datepicker-calendar .ui-datepicker-current-day").removeClass("ui-datepicker-current-day").children().removeClass("ui-state-active");
			$(this).find(".ui-datepicker-calendar TBODY td").each(function () {
				if ($(this).find('a').text() == datepicker.selectedDay && $(this).data('month') == datepicker.selectedMonth) {
					$(this).find('a').addClass("ui-state-active");
					$(this).addClass("ui-datepicker-current-day");
				}
			});
			day = '';
			if (datepicker.selectedDay <= 9) {
				day = '0' + datepicker.selectedDay;
			} else {
				day = datepicker.selectedDay;
			}
			
			month = parseFloat(datepicker.selectedMonth) + 1;
			year = datepicker.selectedYear;
			// queryEvents(day, month+1, year);
			// postsDates();
			filterByDate(day + month + year);
			console.log(day);
			
			// console.log(day+month+year); 
			$('.post').removeClass('hide-by-cat');
			$('.events-cats button').attr('data-active','');
			$('#events-categories option.all').attr('selected','selected');
		},
		onChangeMonthYear: function (year, month, datepicker) {
			if (month > 9) {
				queryEvents(year + '' + month);
			} else {
				queryEvents(year + '0' + month);
			}
			$('.events-cats button#all').attr('data-active','active').siblings().attr('data-active','');
			$('.post').removeClass('hide-by-cat');
		},
		beforeShowDay: function (date) {
			var curr_date = '';
			if (date.getDate() <= 9) {
				curr_date = "0" + date.getDate();
			} else {
				curr_date = date.getDate();
			}
			//var curr_date = "0" + date.getDate();
			var curr_month = date.getMonth() + 1;
			var curr_year = date.getFullYear();
			var formattedDate = 'a' + curr_date + '' + curr_month + '' + curr_year;
			return [true, ' ' + formattedDate, ''];
		}
	});
}

// SCROLL TO EVEN AFTER CHANGE DATE
function scrollToEvent() {
	$('html, body').animate({
		scrollTop: $('#event_wrap').offset().top - 100
	}, 500);
	return false;
}

// HIHGLIGHT DATE IF HAS EVENT
function highlightDate() {
	$('.post').each(function () {
		date = $(this).attr('data-date');
		let arr = date.split(' ');
		arr.forEach(function (elem) {
			$('.ui-datepicker-calendar td.a' + elem).addClass('has-events');
		})
	});
}

// CHECK IF DATE HAS EVENT
function checkEvent() {
	$('.ui-datepicker-calendar tr td').each(function () {
		if (!$(this).hasClass("has-events")) {
			$(this).addClass('ui-state-disabled');
		}
	})
}

// SHOW MORE FUNC
function shMore(callback){
	$( ".post.box" ).eq(8).prevAll().removeClass('sh_more');
	$( ".post.box" ).eq(7).nextAll().addClass('sh_more');
	callback();
}

// LOADMORE EVENTS
function loadmoreEventsCnt() {
	let cnt_el = $('.post.sh_more').length;
	if (cnt_el > 0) {
		$('.ldm.event').removeClass('d-none');
	} else {
		$('.ldm.event').addClass('d-none');
	}
}

function loadmoreEvents(){
	$('.ldm.event').on('click',function(event){
		event.preventDefault();
		$('.post.sh_more').removeClass('sh_more');
		$(this).addClass('d-none');
	});
}

// AJAX EVENTS LOAD
function queryEvents(date) {
	let termid = $('#termId').val();
	let data = {
		'action': 'query_events',
		'date': date,
		'term_id': termid,
	};
	$.ajax({
		url: skm_ajax_params.ajaxurl,
		data: data,
		type: 'POST',
		beforeSend: function (data) {
			$('.preloader').removeClass('hidden');
		},
		success: function (data) {
			$('#event_wrap').html(data);
			highlightDate();
			buildFilterPanel();
			checkEvent();
			shMore(loadmoreEventsCnt);
			$('.preloader').addClass('hidden');
		}
	});
}

function filterByCat() {
	$('.events-cats').on('click', 'button', function () {
		el = $(this).attr('id');
		$('.events-cats button').attr('data-active', '');
		$(this).attr('data-active', 'active');

		if (el == 'all') {
			$('.post').removeClass('hide-by-cat').removeClass('hide-by-date');
			$('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
			$('.ui-state-active').removeClass('ui-state-active');
			buildFilterPanel();
			shMore(loadmoreEventsCnt);
		} else {
			$('.post').each(function () {
				_t = $(this);
				if (!_t.hasClass(el)) {
					_t.addClass('hide-by-cat');
				} else {
					_t.removeClass('hide-by-cat');
				}
			});
			shMoreFilter();
		}
	});

	$('#events-categories').on('change', function () {
		let el_select = $(this).find(":selected").val();
		if (el_select == 'all') {
			$('.post').removeClass('hide-by-cat');
			shMore(loadmoreEventsCnt);
		} else {
			$('.post').each(function () {
				_t = $(this);
				if (!_t.hasClass(el_select)) {
					_t.addClass('hide-by-cat');
				} else {
					_t.removeClass('hide-by-cat');
				}
			});
			shMoreFilter();
		}
	});
}

function filterByDate(date) {
	$('.post').each(function () {
		_t = $(this);
		postDate = _t.attr('data-date');
		// console.log(date);
		$('.post .time span.times').hide();
		$('.post[data-date*="' + date + '"] .time span[class="times ' + date + '"]').show();
		if (postDate.includes(date)) {
			_t.removeClass('hide-by-date');
		} else {
			_t.addClass('hide-by-date');
		}
	});
	shMoreFilter();
	scrollToEvent();
	buildFilterPanel();
}

// SHOW MORE FILTER EVENTS
function shMoreFilter(){
	$('.sh_more').removeClass('sh_more');
	let elms = $('article:not(.hide-by-cat, .hide-by-date)');
	for (var i = 8; i < elms.length; i++) {
		$(elms[i]).addClass('sh_more');
	}
	loadmoreEventsCnt();  
}

// BUILD FILTER PANEL
function buildFilterPanel() {
	hasPosts = false;
	$('.events-cats button:not(.all), .events-cats #events-categories option:not(.all)').each(function () {
		el = $(this).attr('id');
		if ($('.post.' + el).length && $('.post.'+el+':not(.hide-by-date').length > 0) {
			$(this).show();
			hasPosts = true;
		} else {
			$(this).hide();
		}
	});
	if (!hasPosts) {
		$('.no-events').show();
	} else {
		$('.no-events').hide();
	}
}
var $ = jQuery;

if (document.querySelector('.posts-archive-wrapper')) {
  postPreloader();
  filterPostByTag();
  removeFilterPostByTag();
  clearFilterPostByTag();
  clickLoadmore();
}

/** =================
 * POSTS FILTER START
================== */
// PRELOADER
function postPreloader() {
  return new Promise((resolve, reject) => {
    setTimeout(resolve, 1000);
  })
}

postPreloader()
  .then(() => {
    let preloaderEl = document.getElementById('preloader');
    if (preloaderEl) {
      preloaderEl.classList.add('hidden');
      preloaderEl.classList.remove('visible');
    }
  });


// POSTS FILTER
function filterPostByTag() {
  let filter = document.getElementsByClassName('post-filter'),
    clouds = document.querySelector('.filtered_tags');
  Array.prototype.filter.call(filter, (filter) => {
    filter.addEventListener('change', function () {
      let type = this.dataset.type,
        id = this.value,
        i, tag;
      /* Disable selected option */
      filter.options[filter.selectedIndex].setAttribute('disabled', true);

      /* Set data attribute to clouds block */
      if (type == 'tag') {
        clouds.dataset.tag += id + ', ';
        if (id == '') {
          clouds.dataset.tag = '';
          for (i = 0; i < this.options.length; i++) {
            this.options[i].removeAttribute('disabled');
          }
        }
      } else {
        clouds.dataset.cat += id + ', ';
        if (id == '') {
          clouds.dataset.cat = '';
          for (i = 0; i < this.options.length; i++) {
            this.options[i].removeAttribute('disabled');
          }
        }
      }

      /* Create cloud tag */
      tag = `<span class="tag-button ${type}" id="${this.value}"> ${filter.options[filter.selectedIndex].textContent} <span class="remove">+</span></span>`;
      /* Insert Tag to clouds block */
      clouds.insertAdjacentHTML('afterBegin', tag);

      if (clouds.dataset.tag || clouds.dataset.cat != '') {
        $('.clear_all').show();
      } else {
        $('.clear_all').hide();
        clouds.querySelectorAll('.tag-button').forEach((btn) => btn.remove());
      }
      document.getElementById('preloader').classList.remove('hidden');
      document.getElementById('preloader').classList.add('visible');
      ajaxLoadPosts(clouds.dataset.cat, clouds.dataset.tag, 1)
    });
  })
}

// CLEAR ALL TAGS AND CAT FROM FILTER
function clearFilterPostByTag() {
  let filteredTags = document.querySelector('.filtered_tags'),
    clearAll = filteredTags.querySelector('.clear_all'),
    i;
  clearAll.addEventListener('click', function () {
    this.style.display = 'none';
    filteredTags.dataset.tag = '';
    filteredTags.dataset.cat = '';

    filteredTags.querySelectorAll('.tag-button')
      .forEach((item) => {
        item.remove()
      });
    document.querySelectorAll('.post-filter')
      .forEach((select) => {
        select.value = '';
        for (i = 0; i < select.length; i++) {
          select.options[i].removeAttribute('disabled');
        }
      });
      document.getElementById('preloader').classList.remove('hidden');
      document.getElementById('preloader').classList.add('visible');
    ajaxLoadPosts('', '', 1);
  });
}

// REMOVE ITEM FROM FILTER
function removeFilterPostByTag() {
  let filteredTags = document.querySelector('.filtered_tags'),
    clouds = filteredTags.querySelectorAll('.tag-button'),
    selects = document.querySelectorAll('.post-filter'),
    clearAll = filteredTags.querySelector('.clear_all'),
    tag, cat;
  clouds.forEach((cloud) => {
    cloud.querySelector('.remove').addEventListener('click', () => {
      cloud.remove();
      selects.forEach(function (select) {
        let option = select.options.namedItem(cloud.id);
        if (option) {
          option.removeAttribute('disabled');
          if (select.value == option.value) {
            option.removeAttribute('selected');
          }
        }
      });

      let cat = filteredTags.dataset.cat.replace(cloud.id + ', ', '');
      let tag = filteredTags.dataset.tag.replace(cloud.id + ', ', '');
      filteredTags.dataset.cat = cat;
      filteredTags.dataset.tag = tag;
      if (cat == '' && tag == '') {
        $('.clear_all').hide();
      }
      document.getElementById('preloader').classList.remove('hidden');
      document.getElementById('preloader').classList.add('visible');
      ajaxLoadPosts(cat, tag, 1);
    });

  });
}

// LOADMORE BUTTON
function clickLoadmore() {
  let btn = document.getElementById('loadmore');
  if (btn) {
    btn.addEventListener('click', () => {
      document.getElementById('preloader').classList.remove('hidden');
      document.getElementById('preloader').classList.add('visible');
      ajaxLoadPosts('', '', ++skm_ajax_params.current_page);
    });
  }
}

// AJAX LOAD POSTS
function ajaxLoadPosts(cat = '', tag = '', page = 1) {
  let wrapp = document.getElementById('newsWrapper'),
  loadmore = document.getElementById('loadmore'),
  clouds = document.querySelector('.filtered_tags');
  cat = clouds.dataset.cat;
  tag = clouds.dataset.tag;
  data = {
    'action': 'loadmore',
    'cats': cat,
    'tags': tag,
    //'query': skm_ajax_params.posts,
    'page': page,
  }
  params = new URLSearchParams(data);
  postData(skm_ajax_params.ajaxurl, params)
    .then(data => {

      if (page == 1) {
        wrapp.innerHTML = data;
        skm_ajax_params.current_page = 1;
        console.log('log1', page);
      } else {
        console.log('log2', page);
        wrapp.insertAdjacentHTML('beforeEnd', data);
      }
      if (data.includes('max-pages')) {
        var dataCount = data.match(">(.*)</span>");
        console.log('SPAN:', dataCount[1]);
        console.log('CURR:', skm_ajax_params.current_page);
        if(loadmore) {
          if (page == dataCount[1]) {
            loadmore.style.display = 'none';
          } else {
            loadmore.style.display = 'inline-block';
          }
        }
      }
      document.getElementById('preloader').classList.add('hidden');
      document.getElementById('preloader').classList.remove('visible');
      removeFilterPostByTag();
      // end loader
    })
    .catch(error => console.error(error));
}

// AJAX LOADMORE POSTS OLD
function ajaxLoadmorePost(cat = '', tag = '') {
  let wrapp = document.getElementById('newsWrapper'),
    clouds = document.querySelector('.filtered_tags');
  cat = clouds.dataset.cat;
  tag = clouds.dataset.tag;
  data = {
    'action': 'loadmore',
    'cats': cat,
    'tags': tag,
    //'query': skm_ajax_params.posts,
    'page': skm_ajax_params.current_page,
  }
  params = new URLSearchParams(data);
  postData(skm_ajax_params.ajaxurl, params)
    .then(data => {

      wrapp.insertAdjacentHTML('beforeEnd', data);
      skm_ajax_params.current_page++;
      removeFilterPostByTag();
      if (skm_ajax_params.current_page == skm_ajax_params.max_page) {
        document.getElementById('loadmore').style.display = 'none';
      }

      console.log('Max Page:', skm_ajax_params.max_page);
      console.log('Current Page:', skm_ajax_params.current_page);
      // end loader
    })
    .catch(error => console.error(error));
}
// AJAX POST FILTER OLD
function ajaxPostByTag(cat = '', tag = '') {
  let wrapp = document.getElementById('newsWrapper');
  data = {
    'action': 'filterpost',
    'cats': cat,
    'tags': tag,
    //'query': skm_ajax_params.posts,
    'page': skm_ajax_params.current_page,
  }
  params = new URLSearchParams(data);
  postData(skm_ajax_params.ajaxurl, params)
    .then(data => {
      // start loader
      skm_ajax_params.current_page = 1;
      skm_ajax_params.posts = data.query;
      skm_ajax_params.max_page = data.max_page;

      wrapp.innerHTML = data;
      removeFilterPostByTag();
      console.log(data);

      // end loader
      if (data.includes('max-pages')) {
        var dataCount = data.match(">(.*)</span>");
        console.log('SPAN:', dataCount[1]);
        console.log('Curr:', skm_ajax_params.current_page);
        if (skm_ajax_params.current_page == dataCount[1]) {
          document.getElementById('loadmore').style.display = 'none';
        }
      }

      console.log('Max Page:', data.max_num_pages);
      console.log('Current Page:', skm_ajax_params.current_page);
    })
    .catch(error => console.error(error));
}

/** =================
 * POSTS FILTER END
================== */